//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { deserializeMediaItem } from '@apis/media-library/mediaLibraryApiUtils';
import { IMaterializedTikTokVideoWithMetrics } from '@apis/tiktok-analytics/tiktokAnalyticsApiModel';
import { Serialized } from '@utils/types/Serialized';

export const deserializeVideosWithMetrics = (
  videos: Serialized<IMaterializedTikTokVideoWithMetrics[]>,
): IMaterializedTikTokVideoWithMetrics[] => {
  return videos.map((videoWithMetrics) => ({
    ...videoWithMetrics,
    mediaItem:
      videoWithMetrics.mediaItem &&
      deserializeMediaItem(videoWithMetrics.mediaItem),
  }));
};
